import { render, staticRenderFns } from "./header.vue?vue&type=template&id=30de9f9c"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30de9f9c')) {
      api.createRecord('30de9f9c', component.options)
    } else {
      api.reload('30de9f9c', component.options)
    }
    module.hot.accept("./header.vue?vue&type=template&id=30de9f9c", function () {
      api.rerender('30de9f9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/header.vue"
export default component.exports